// تحميل MapLibre كحزمة UMD مستضافة معنا (نفس النطاق): تُنشئ عاملها بنفسها فتعمل على سفاري/آيفون
// وأندرويد وكل المتصفحات، وبلا اعتماد على أي CDN خارجي قد يُحجب.
const VERSION = "5.24.0";
const LOCAL_JS = "/maplibre-gl.js";
const CDN_JS = `https://unpkg.com/maplibre-gl@${VERSION}/dist/maplibre-gl.js`;
let promise = null;

const addCss = () => {
  if (document.getElementById("maplibre-css")) return;
  const link = document.createElement("link");
  link.id = "maplibre-css";
  link.rel = "stylesheet";
  link.href = "/maplibre-gl.css";
  document.head.appendChild(link);
};

const inject = (src) =>
  new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => (window.maplibregl ? resolve(window.maplibregl) : reject(new Error("no_namespace")));
    script.onerror = () => reject(new Error(`script_error:${src}`));
    document.head.appendChild(script);
  });

export const loadMapLibre = () => {
  if (window.maplibregl) return Promise.resolve(window.maplibregl);
  if (promise) return promise;
  addCss();
  promise = inject(LOCAL_JS)
    .catch(() => inject(CDN_JS))
    .then((gl) => {
      if (gl.getRTLTextPluginStatus?.() === "unavailable") {
        gl.setRTLTextPlugin("/mapbox-gl-rtl-text.js", true);
      }
      return gl;
    });
  return promise;
};
